import { render, staticRenderFns } from "./ConductoresPantalla.vue?vue&type=template&id=64fa2bf8&"
import script from "./ConductoresPantalla.vue?vue&type=script&lang=ts&"
export * from "./ConductoresPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports